module.exports = __webpack_public_path__ + "img/r-81.268f503e.jpg";